/**
 * Partner ROUTES
 */
const routes = [
  //Partner
  {
    path: '/Partner/Filter',
    name: 'PartnerFilterViewComponent',
    component: 'Partner/PartnerFilterViewComponent'
  },
  {
    path: '/Partner/Editor/:Id?',
    name: 'PartnerEditorViewComponent',
    component: 'Partner/PartnerEditorViewComponent',
    props: true
  }
];

export default routes;
